import { useState } from "react";
import { BaseButton } from "../../../../components/Button/BaseButton.tsx";
import { Icon } from "../../../../components/Icon/Icon.tsx";
import { useAppMutation } from "../../../../http/useAppMutation.ts";
import { FROM_INSPIRATION_CONTENT_AS_CURATOR_PRESET } from "../../../boardState/constants.ts";
import { ActionContentTile } from "../../../components/ActionContentTile.tsx";
import { useRedirectToBoard } from "../../../hooks/useRedirectToBoard.ts";
import { useUser } from "../../../hooks/useUser.ts";
import { useWorkspaceUuid } from "../../../hooks/useWorkspaceUuid.ts";
import type { InspirationContent } from "../../../types.ts";
import { isUserAllowedTo } from "../../../utils/isUserAllowedTo.ts";
import { InspirationActionsDialog } from "./InspirationActionsDialog.tsx";

export const InspirationTile = ({
  content,
}: {
  content: InspirationContent;
}) => {
  const workspaceUuid = useWorkspaceUuid();
  const { user } = useUser();

  const redirectToBoard = useRedirectToBoard();
  const { mutate: getOrCreateAssetFromContent } = useAppMutation({
    path: "contents/get-or-create-asset-from-content",
    invalidate: [],
    onSuccess: (response: {
      data: { asset_uuid: string; board_uuid: string };
    }) => {
      redirectToBoard({
        uuid: response.data.board_uuid,
        boardStatePreset: FROM_INSPIRATION_CONTENT_AS_CURATOR_PRESET,
        baseBoardState: {
          selectedAssetUuid: response.data.asset_uuid,
        },
      });
    },
  }).mutation;

  const [isDialogOpen, setIsDialogOpen] = useState(false);

  return (
    <>
      <InspirationActionsDialog
        dialogOpen={isDialogOpen}
        onDialogChange={setIsDialogOpen}
        inspirationContent={content}
      />
      <ActionContentTile
        content={{
          status: "SUCCEEDED",
          purchased_at: null,
          is_curated: true,
          is_from_edit: false,
          node_uuid: null,
          information: {
            user_email: null,
            generation_parameters: null,
          },
          ...content,
        }}
        onClick={() => setIsDialogOpen(true)}
        bottomRightElement={
          <div className="flex-row items-center gap-200 invisible group-hover:visible">
            {user && isUserAllowedTo(user, "contents:curate") && (
              <BaseButton
                className="z-10 tile-action hover:brightness-95 active:brightness-90 flex-row-center gap-200"
                onClick={() =>
                  getOrCreateAssetFromContent({
                    uuid: content.uuid,
                    workspace_uuid: workspaceUuid,
                  })
                }
              >
                <Icon name="ExternalLink" size="sm" />
              </BaseButton>
            )}
            <BaseButton
              className="z-10 tile-action hover:brightness-95 active:brightness-90 flex-row-center gap-200"
              onClick={() => setIsDialogOpen(true)}
            >
              <Icon name="IterationCcw" size="sm" />
              Start here
            </BaseButton>
          </div>
        }
      />
    </>
  );
};
